import axios from "axios"

export const NotificationsService = {
  getNotifications(params: $TSMigrationFixMe) {
    return axios.get(
      `/Notification/by-filters?SortingCriteria=creationTime%20desc`,
      {
        params,
        baseURL: import.meta.env.REACT_APP_API_NOTIFICATIONS,
      }
    )
  },

  getNotificationsTypes() {
    return axios.get(`/Notification/types`, {
      baseURL: import.meta.env.REACT_APP_API_NOTIFICATIONS,
    })
  },

  getNotificationsCategories() {
    return axios.get(`/Notification/categories`, {
      baseURL: import.meta.env.REACT_APP_API_NOTIFICATIONS,
    })
  },

  markNotificationAsRead(
    read: $TSMigrationFixMe,
    notificationId: $TSMigrationFixMe
  ) {
    return axios.put(`/Notification/set-read/${read}`, [notificationId], {
      baseURL: import.meta.env.REACT_APP_API_NOTIFICATIONS,
    })
  },

  markAllNotificationsAsRead() {
    return axios.put(`/Notification/read-all`, null, {
      baseURL: import.meta.env.REACT_APP_API_NOTIFICATIONS,
    })
  },
}
